var exports = {
  "pz": "sidebar__ddo0A5",
  "$X": "sidebarStack__AnZPKl",
  "SD": "resourceLinks__ZQMNBv",
  "VA": "resourceLink__d8egy4",
  "wZ": "repoIcon__rPX7D7",
  "D3": "onlyDesktop__pSodNn",
};

module.exports = exports;
